import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './components/AuthProvider';

import Login from './components/Login';
import ManualCreateUser from './components/ManualCreateUser';
import TeamManagement from './components/TeamManagement';
import Dashboard from './components/Dashboard';
import NewInspection from './components/NewInspection';
import InspectionView from './components/InspectionView';

const App = () => {
  const { currentUser, role } = useAuth();

  const [inspectionHistory, setInspectionHistory] = useState([]);
  const [currentInspection, setCurrentInspection] = useState(null);

  if (!currentUser) {
    return <Login />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <Dashboard
            inspectionHistory={inspectionHistory}
            setCurrentInspection={setCurrentInspection}
            setInspectionHistory={setInspectionHistory}
          />
        } />
        <Route path="/new" element={
          <NewInspection
            inspectionHistory={inspectionHistory}
            setCurrentInspection={setCurrentInspection}
            setInspectionHistory={setInspectionHistory}
          />
        } />
        <Route path="/inspection" element={
          <InspectionView
            currentInspection={currentInspection}
            setCurrentInspection={setCurrentInspection}
            inspectionHistory={inspectionHistory}
            setInspectionHistory={setInspectionHistory}
          />
        } />
        {role === 'admin' && (
          <>
            <Route path="/create-user" element={<ManualCreateUser />} />
            <Route path="/team" element={<TeamManagement />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;
